export const getFilmListItemElementId = (filmId) => {
    return `v-showtime-picker-film-list__item--film-id-${filmId}`.toLowerCase();
};
